import Vue from 'vue'
import BFormGroup from 'b-form-group'
import Vuemerang from 'vuemerang'
import 'vuemerang/dist/vuemerang.css'

Vue.use(BFormGroup)
Vue.use(Vuemerang, {
  theme: {
    colors: {
      primary: '#000000',
      secondary: '#9f3223',
      success: 'rgb(10, 148, 26)',
      danger: 'rgb(250, 0, 42)',
      warning: '#c99100',
      dark: 'rgb(36, 33, 69)',
      gray: '#afbbc6'
    }
  }
})
